import { RGBColor } from "react-color";

const getHslFromRgba = (rgba: RGBColor): any => {
  // Extract RGB values
  const r = rgba.r / 255;
  const g = rgba.g / 255;
  const b = rgba.b / 255;

  // Find the min and max values
  const cmin = Math.min(r, g, b);
  const cmax = Math.max(r, g, b);
  const delta = cmax - cmin;

  let h = 0;
  let s = 0;
  let l = 0;

  // Calculate hue
  if (delta === 0) {
    h = 0;
  } else if (cmax === r) {
    h = ((g - b) / delta) % 6;
  } else if (cmax === g) {
    h = (b - r) / delta + 2;
  } else {
    h = (r - g) / delta + 4;
  }

  h = Math.round(h * 60);

  // Make sure hue is positive
  if (h < 0) {
    h += 360;
  }

  // Calculate lightness
  l = (cmax + cmin) / 2;

  // Calculate saturation
  s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));

  // Round values to percentage
  h = Math.round(h);
  s = Math.round(s * 100);
  l = Math.round(l * 100);

  // Include alpha channel
  const a = rgba.a || 1;

  return { h, s, l, a };
};

export default getHslFromRgba;
